import { LoadState } from "../../constants/enums";
import { IRestrictedWords } from "./restrictedWords.types";


export const initialRestrictedWords: IRestrictedWords = {
  list: {
    data: [],
    loading: LoadState.NotLoaded,
    error: null,
    totalRecords: 0,
  },
};





